import { GENERAL_IDENTIFIERS, IDENTIFIERS } from '../types/Identifiers';
import { identify } from './utils/identify';
import { getSimplifiedTagLabel } from '../tags/advanced/get-simplified-tag-label';
import { filterDuplicateCustomTags } from '../tags/filters/filter-duplicate-custom-tags';
var getIdentifier = function (tag) {
    var _a;
    var identifier = identify(tag);
    if (identifier === IDENTIFIERS.STRUCTURED_DATA) {
        if ((_a = tag === null || tag === void 0 ? void 0 : tag.metaData) === null || _a === void 0 ? void 0 : _a.schemaType) {
            return tag.metaData.schemaType;
        }
        try {
            var jsonData = JSON.parse(tag.children);
            var scriptType = jsonData && jsonData['@type'];
            return identifier + " - " + scriptType;
        }
        catch (error) { }
    }
    if (!identifier && tag.props && !tag.custom) {
        var simplifiedTagLabel = getSimplifiedTagLabel(tag);
        var simplifiedTagIdentifier = getSimplifiedTagIdentifier(simplifiedTagLabel);
        if (simplifiedTagIdentifier) {
            return simplifiedTagIdentifier;
        }
    }
    return identifier;
};
var getSimplifiedTagIdentifier = function (simplifiedTagLabel) {
    var simplifiedIdentifier = Object.values(IDENTIFIERS).find(function (identifier) { return simplifiedTagLabel === identifier.toLowerCase(); });
    return simplifiedIdentifier || simplifiedTagLabel;
};
export function merge(a, b) {
    var tags = [];
    var uniqueTagCache = {};
    var safeA = Array.isArray(a) ? a : [];
    var safeB = Array.isArray(b) ? b : [];
    var safeAWithoutDuplicateCustomTags = filterDuplicateCustomTags(safeA, safeB);
    var merged = []
        .concat(safeB.some(function (tag) { return tag.allowMultiple; })
        ? safeAWithoutDuplicateCustomTags.filter(function (tag) { return !tag.allowMultiple; })
        : safeAWithoutDuplicateCustomTags)
        .concat(safeB);
    for (var i = merged.length - 1; i >= 0; i--) {
        var isUniqueTag = !merged[i].allowMultiple;
        var identifier = getIdentifier(merged[i]);
        if (isUniqueTag && identifier) {
            if (!uniqueTagCache[identifier]) {
                tags.unshift(merged[i]);
                if (!Object.keys(GENERAL_IDENTIFIERS).includes(identifier)) {
                    uniqueTagCache[identifier] = true;
                }
            }
        }
        else {
            tags.unshift(merged[i]);
        }
    }
    return tags;
}
